module.exports = __webpack_public_path__ + "static/media/close~dCdEQihZ.3fd88e4b.svg";